import { render, staticRenderFns } from "./comp_StarsSection.vue?vue&type=template&id=1d429e4a&scoped=true&"
import script from "./comp_StarsSection.vue?vue&type=script&lang=js&"
export * from "./comp_StarsSection.vue?vue&type=script&lang=js&"
import style0 from "./comp_StarsSection.vue?vue&type=style&index=0&id=1d429e4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d429e4a",
  null
  
)

export default component.exports